/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ViewSettings
 */
export interface ViewSettings {
  /**
   *
   * @type {number}
   * @memberof ViewSettings
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ViewSettings
   */
  tableName: string;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof ViewSettings
   */
  columnSettings: { [key: string]: boolean };
  /**
   *
   * @type {string}
   * @memberof ViewSettings
   */
  urlParameters?: string | null;
}

/**
 * Check if a given object implements the ViewSettings interface.
 */
export function instanceOfViewSettings(value: object): value is ViewSettings {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('tableName' in value) || value['tableName'] === undefined) return false;
  if (!('columnSettings' in value) || value['columnSettings'] === undefined) return false;
  return true;
}

export function ViewSettingsFromJSON(json: any): ViewSettings {
  return ViewSettingsFromJSONTyped(json, false);
}

export function ViewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    tableName: json['table_name'],
    columnSettings: json['column_settings'],
    urlParameters: json['url_parameters'] == null ? undefined : json['url_parameters'],
  };
}

export function ViewSettingsToJSON(value?: Omit<ViewSettings, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    table_name: value['tableName'],
    column_settings: value['columnSettings'],
    url_parameters: value['urlParameters'],
  };
}
